<div class="sm:flex items-center justify-between mb-4">
  <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="size-6">
      <mask id="mask0_848_1764" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24" style="mask-type: alpha;">
        <rect width="24" height="24" fill="#C19725"></rect>
      </mask>
      <g mask="url(#mask0_848_1764)">
        <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725"></path>
      </g>
    </svg>
   <img [src]="customerDetails?.documents?.[0]?.doc_user_img"
     alt="Report"
     class="size-6 sm:size-8 lg:size-10">

    <span class="font-semibold text-sm sm:text-base lg:text-xl text-c19725">{{customerDetails?.user_title}}</span>
    <span class="font-semibold text-sm sm:text-base lg:text-xl text-c19725">{{customerDetails?.name}}</span>
    <span class="font-semibold text-sm sm:text-base lg:text-xl text-c19725">| Mobile No. :
      {{customerDetails?.mobilenumber}}</span>
    <span class="font-semibold text-sm sm:text-base lg:text-xl text-c19725">| Type :
      {{customerDetails?.user_customer_type}}</span>
  </div>
  <!-- <a routerLink="/product-creation" class="block cursor-pointer px-3 py-1.5 text-xs sm:text-sm lg:text-base font-semibold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center dark:bg-c19725 dark:hover:bg-[#fdffc6]">
    Add Product
  </a> -->
</div>
<div class="w-full py-3 px-4">

    <div class="flex justify-end">
      <a href="#"
        class="flex items-center w-28 px-4 py-1 rounded-[5px] border border-[#BB0000] bg-[#BB0000] text-white text-sm lg:text-base
               hover:bg-white hover:text-[#BB0000] hover:shadow-lg">
        <img class="w-4 h-4 mr-2" src="/assets/images/stock/youtube.png" alt="youtube" />
        Help
      </a>

  </div>
  <!-- Parent wrapper to center content vertically & horizontally -->
  <div class="flex justify-center items-center min-h-[100px] py-4 ">

    <div class="flex flex-wrap gap-x-8 gap-y-6">

      <!-- First input + GO -->
      <form [formGroup]="addProductForm">
        <div class="flex items-center relative">
          <div class="relative w-full">
            <input
              readonly
              type="text"
              id="start_range_1"
              formControlName="start_range_1"
              (focus)="onFocusInput()"
              (blur)="onBlurInput()"
              autocomplete="off"
              (keydown)="onKeyDown($event)"
              class="block px-20 py-4.5 w-full text-base text-gray-800 bg-gradient-to-r from-white via-yellow-50 to-white
                     rounded-l-md rounded-r-none border border-[#DCDCDC] appearance-none focus:outline-none focus:ring-0
                     focus:border-[#c19725] peer shadow-sm"
              placeholder=" "
            />
            <label for="start_range_1"
              class="absolute text-base text-[#898989] duration-300 transform -translate-y-5 scale-90 top-3 z-0 bg-white px-2
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-3 peer-focus:scale-90 peer-focus:-translate-y-5 start-1">
              Add Product Id / Barcode / RFID
            </label>

            <!-- Dropdown -->
            <ul *ngIf="isDropdownVisible && filteredBarcodes.length"
              class="absolute left-0 right-0 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto z-50">
              <li *ngFor="let item of filteredBarcodes; let i = index"
              (mousedown)="$event.preventDefault(); onSelectBarcode(item.barcode)"
              [class.bg-yellow-100]="i === selectedIndex"
              class="px-4 py-2 cursor-pointer hover:bg-yellow-50">
              {{ item.barcode }}
              </li>
            </ul>

          </div>

          <button type="submit" (click)="onGoClick('add', selectedProductCode, selectedQuantity, selectedWt, selectedFinalValue)"
            class="px-5 py-4 rounded-r-md rounded-l-none border border-[#C19725] bg-[#C19725] text-white
                   text-base xl:text-lg font-bold capitalize text-center
                   hover:bg-white hover:text-[#C19725] hover:shadow-lg
                   transition-shadow shadow-sm focus:ring-0 focus:outline-none">
            GO
          </button>
        </div>
      </form>

      <!-- Second input + GO -->
      <!-- <div class="flex items-center">
        <div class="relative">
          <input type="text" id="start_range_2" class="block px-20 py-4.5 w-full text-base text-gray-800 bg-gradient-to-r from-white via-yellow-50 to-white
                   rounded-l-md rounded-r-none border border-[#DCDCDC] appearance-none focus:outline-none focus:ring-0
                   focus:border-[#c19725] peer shadow-sm" placeholder=" " />
          <label for="start_range_2" class="absolute text-base text-[#898989] duration-300 transform -translate-y-5 scale-90 top-3 z-0 bg-white px-2
                   peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                   peer-focus:top-3 peer-focus:scale-90 peer-focus:-translate-y-5 start-1">
            Return Product Id / Barcode / RFID
          </label>
        </div>


        <button type="submit" class="px-5 py-4 rounded-r-md rounded-l-none border border-[#C19725] bg-[#C19725] text-white
         text-base xl:text-lg font-bold capitalize text-center
         hover:bg-white hover:text-[#C19725] hover:shadow-lg
         transition-shadow shadow-sm focus:ring-0 focus:outline-none">
          GO
        </button>
      </div> -->

    </div>
  </div>

  <div *ngIf="isProductDetailsVisible">
  <form [formGroup]="sellProductForm">
  <div class="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-1">

    <div class="mt--10 pt-2 w-full bg-[#E6EFFF] rounded-t-[5px] p-4">




      <div class="flex flex-nowrap gap-4 overflow-x-auto">

        <!-- 1. Bill Date -->
        <div>
          <div class="relative w-full max-w-xs">
            <input datepicker datepicker-autohide id="billDate" type="date" formControlName="stout_bill_date"
              class="block w-full px-2 py-2 text-sm text-gray-700 font-normal bg-white rounded-md border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
              placeholder=" " />
            <div class="absolute inset-y-0 end-0 flex items-center pe-1 pointer-events-none">
              <svg class="size-6" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.9773 3.67371H4.02272C3.48663 3.67491 2.97284 3.8884 2.59376 4.26748C2.21469 4.64655 2.0012 5.16034 2 5.69644V20.651C2.0012 21.1871 2.21469 21.7009 2.59376 22.0799C2.97284 22.459 3.48663 22.6725 4.02272 22.6737H18.9773C19.5134 22.6725 20.0272 22.459 20.4062 22.0799C20.7853 21.7009 20.9988 21.1871 21 20.651V5.69644C20.9988 5.16034 20.7853 4.64655 20.4062 4.26748C20.0272 3.8884 19.5134 3.67491 18.9773 3.67371Z"
                  stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M6.06836 9.59113H10.8865" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M6.06836 13.2744H16.5002" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M8.56836 2.5V6.44491" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M14.4326 2.5V6.44491" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
              </svg>
            </div>
            <label for="billDate"
              class="capitalize absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Bill Date</label>


          </div>
        </div>

        <!-- 2. Customer Name -->
        <div>
          <div class="relative w-full max-w-xs">
            <input id="customerName" type="text" formControlName="stout_customer_name"
              class="block w-full px-2 py-2 text-sm text-gray-700 font-normal bg-white rounded-md border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
              placeholder=" " />
            <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Customer Name</label>

          </div>
        </div>
 <!-- 3. Billing Name -->
        <div>
          <div class="relative w-full max-w-xs">
            <input id="billingName" type="text" formControlName="stout_billing_name"
              class="block w-full px-2 py-2 text-sm text-gray-700 font-normal bg-white rounded-md border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
              placeholder=" " />
            <label for="billingName" class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"> Billing Name</label>
          </div>
        </div>

        <!-- 4. Invoice Number -->
        <div>
          <div class="relative w-full max-w-xs">
            <input id="invoiceNumber" type="text" formControlName="stout_invoice_number"
              class="block w-full px-2 py-2 text-sm text-gray-700 font-normal bg-white rounded-md border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
              placeholder=" " />
            <label for="invoiceNumber" class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Invoice Number</label>

          </div>
        </div>

        <!-- 5. Firm Name -->
        <div class="col-span-1">
          <div class="relative">
            <select
              formControlName="stout_firm_id"
              name="firmType"
              id="stout_firm_id"
              class="block pl-2 pr-6 py-2 w-full text-sm lg:text-sm text-444 capitalize font-normal bg-white rounded-lg border-1 border-dcdcdc appearance-none !bg-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer"
            >
              <option value="" disabled selected>Select firm</option>
              <option *ngFor="let firm of firmTypes" [value]="firm.id">
                {{ firm.name }}
              </option>
            </select>

            <div
              class="absolute inset-y-0 right-2 flex items-center pointer-events-none"
            >
              <svg
                width="14"
                height="7"
                viewBox="0 0 14 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z"
                  fill="#C19725"
                />
              </svg>
            </div>
            <label
              for="rproduct_firm_id"
              class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
              >Firm</label
            >
          </div>
          </div>




        <!-- 6. Account -->
        <div>
          <div class="relative w-full max-w-xs">
            <input id="account" type="text" formControlName="stout_account"
              class="block w-full px-2 py-2 text-sm text-gray-700 font-normal bg-white rounded-md border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
              placeholder=" " />
            <label for="account" class="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 text-sm bg-white px-1 transition-all duration-300 transform origin-left
                     scale-100 peer-placeholder-shown:scale-100 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2
                     peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:top-2 peer-focus:text-[#c19725]">
              Account
            </label>
          </div>
        </div>

        <!-- 7. Sale Executive -->
        <div>
          <div class="relative w-full max-w-xs">
            <input id="saleExecutive" type="text" formControlName="stout_sale_executive"
              class="block w-full px-2 py-2 text-sm text-gray-700 font-normal bg-white rounded-md border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
              placeholder=" " />
            <label for="saleExecutive" class="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 text-sm bg-white px-1 transition-all duration-300 transform origin-left
                     scale-100 peer-placeholder-shown:scale-100 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2
                     peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:top-2 peer-focus:text-[#c19725]">
              Sale Executive
            </label>
          </div>
        </div>

        <!-- 8. Sale Month -->
        <div>
          <div class="relative w-full max-w-xs">
            <input datepicker datepicker-autohide id="billDate" type="date" formControlName="stout_sale_month"
              class="block w-full px-2 py-2 text-sm text-gray-700 font-normal bg-white rounded-md border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
              placeholder=" " />
            <div class="absolute inset-y-0 end-0 flex items-center pe-1 pointer-events-none">
              <svg class="size-6" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.9773 3.67371H4.02272C3.48663 3.67491 2.97284 3.8884 2.59376 4.26748C2.21469 4.64655 2.0012 5.16034 2 5.69644V20.651C2.0012 21.1871 2.21469 21.7009 2.59376 22.0799C2.97284 22.459 3.48663 22.6725 4.02272 22.6737H18.9773C19.5134 22.6725 20.0272 22.459 20.4062 22.0799C20.7853 21.7009 20.9988 21.1871 21 20.651V5.69644C20.9988 5.16034 20.7853 4.64655 20.4062 4.26748C20.0272 3.8884 19.5134 3.67491 18.9773 3.67371Z"
                  stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M6.06836 9.59113H10.8865" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M6.06836 13.2744H16.5002" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M8.56836 2.5V6.44491" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M14.4326 2.5V6.44491" stroke="#C19725" stroke-miterlimit="10" stroke-linecap="round" />
              </svg>
            </div>

              <label for="billDate"
              class="capitalize absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Sale Month</label>

          </div>
        </div>



      </div>
    </div>





    <!-- <a href="#" class="mx-1">
          <img class="w-7 h-7" src="/assets/images/stock/storage.png" alt="storage" />
        </a>
        <a href="#" class="mx-1">
          <img class="w-7 h-7" src="/assets/images/stock/webcam.png" alt="webcam" />
        </a> -->
    <!-- </div>
    </div> -->

    <!-- The main container for your component -->
    <div class="col-span-4 sm:col-span-4 lg:col-span-2 bg-[#E6EFFF] rounded-b-[5px] p-0 order-3">
      <div class="col-span-1 w-full bg-[#FFF9F9] p-3 rounded-md">
        <!--
        This is the grid container.
        - grid-cols-2: 2 columns on the smallest screens
        - sm:grid-cols-4: 4 columns on small screens and up
        - md:grid-cols-8: 8 columns on medium screens and up (This is the key change for your request)
      -->
        <div class="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-8 gap-2 sm:gap-2.5 lg:gap-3">

          <!-- Tab 1: Metal -->
          <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_metal_type"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Metal</label>
            </div>
          </div>

          <!-- Tab 2: Category -->
          <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_item_category"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Category</label>
            </div>
          </div>

          <!-- Tab 3: Name -->
          <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_item_name"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Name</label>
            </div>
          </div>

          <!-- Tab 4: Pro code -->
          <div class="col-span-1">

            <div class="flex items-center">
              <div class="relative">
                <input type="text" id="" placeholder=" " formControlName="stout_product"
                  class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-l-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer" /><label
                  for=""
                  class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Product</label>
              </div>

              <div class="relative">
                <input type="text" id="" placeholder=" " formControlName="stout_item_code"
                  class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-r-md border-1 border-dcdcdc appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-c19725 peer" /><label
                  for=""
                  class="absolute text-sm lg:text-sm text-[#898989] dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white dark:bg-gray-900 px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Code</label>

              </div>
            </div>

          </div>

          <!-- Tab 5: Qty -->
          <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_quantity"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Qty</label>
            </div>
          </div>

<!--
          <div class="flex w-full gap-2">

            <div class="w-[60%] relative">
              <input type="text" placeholder=" " formControlName="stout_gs_weight"
                class="block w-full px-3 py-2 text-sm text-[#444] font-normal bg-white rounded-md border border-[#DCDCDC] appearance-none peer focus:outline-none focus:ring-0 focus:border-[#c19725]" />
              <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
                Gs wt
              </label>
            </div>


            <div class="w-[40%]">
              <app-custom-select label="Unit" [options]="unitTypes" formControlName="st_making_charges_type" formControlName="stout_gs_wt_unit"
                [(selected)]="selectedMakingChargesUnit" selectId="selectedMakingChargesUnit">
              </app-custom-select>
            </div>

          </div> -->
<!--
          <div class="flex w-full gap-2">

            <div class="w-[60%] relative">
              <input type="text" placeholder=" " formControlName="stout_less_weight"
                class="block w-full px-3 py-2 text-sm text-[#444] font-normal bg-white rounded-md border border-[#DCDCDC] appearance-none peer focus:outline-none focus:ring-0 focus:border-[#c19725]" />
              <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
                Less wt
              </label>
            </div>


            <div class="w-[40%]">
              <app-custom-select label="Unit" [options]="unitTypes" formControlName="stout_less_wt_unit"
                [(selected)]="selectedLessWtUnit" selectId="lessWtUnit">
              </app-custom-select>
            </div>

          </div> -->


          <!-- <div class="flex w-full gap-2">


            <div class="w-[60%] relative">
              <input type="text" placeholder=" " formControlName="stout_pkt_weight"
                class="block w-full px-3 py-2 text-sm text-[#444] font-normal bg-white rounded-md border border-[#DCDCDC] appearance-none peer focus:outline-none focus:ring-0 focus:border-[#c19725]" />
              <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
                Pkt wt
              </label>
            </div>


            <div class="w-[40%]">
              <app-custom-select label="Unit" [options]="unitTypes" formControlName="pkt_wt_unit" formControlName="stout_pkt_wt_unit"
                [(selected)]="selectedPktWtUnit" selectId="pktWtUnit">
              </app-custom-select>
            </div>

          </div> -->


          <!-- <div class="flex w-full gap-2">


            <div class="w-[60%] relative">
              <input type="text" placeholder=" " formControlName="stout_net_weight"
                class="block w-full px-3 py-2 text-sm text-[#444] font-normal bg-white rounded-md border border-[#DCDCDC] appearance-none peer focus:outline-none focus:ring-0 focus:border-[#c19725]" />
              <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
                Net wt
              </label>
            </div>


            <div class="w-[40%]">
              <app-custom-select label="Unit" [options]="unitTypes" formControlName="net_wt_unit" formControlName="stout_net_wt_unit"
                [(selected)]="selectedNetWtUnit" selectId="netWtUnit">
              </app-custom-select>
            </div>

          </div> -->

          <!-- <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_tag_weight"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Tag
                wt</label>
            </div>
          </div> -->


          <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_purity"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Purity</label>
            </div>
          </div>


          <!-- <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_cust_wastage_weight"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">WST</label>
            </div>
          </div> -->


          <!-- <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_f_pur"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">F.Pur</label>
            </div>
          </div> -->


          <!-- <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_v_a"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">V/A</label>
            </div>
          </div> -->


          <!-- <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_fine_weight"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">F.wt</label>
            </div>
          </div> -->

          <!-- <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_v_a_wt"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">V/A
                wt</label>
            </div>
          </div> -->

          <!-- <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_final_fine_weight"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">FF
                wt</label>
            </div>
          </div> -->

          <!-- <div class="flex w-full gap-2">


            <div class="w-1/2 relative">
              <input type="text" placeholder=" " formControlName="stout_cgst_percent"
                class="block w-full px-3 py-2 text-sm text-[#444] font-normal bg-white rounded-md border border-[#DCDCDC] appearance-none peer focus:outline-none focus:ring-0 focus:border-[#c19725]" />
              <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
                CGST %
              </label>
            </div>


            <div class="w-1/2 relative">
              <input type="text" placeholder=" " formControlName="stout_cgst_amt"
                class="block w-full px-3 py-2 text-sm text-[#444] font-normal bg-white rounded-md border border-[#DCDCDC] appearance-none peer focus:outline-none focus:ring-0 focus:border-[#c19725]" />
              <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
                CGST Amt
              </label>
            </div>

          </div> -->

          <!-- <div class="flex w-full gap-2">


            <div class="w-1/2 relative">
              <input type="text" placeholder=" " formControlName="stout_sgst_percent"
                class="block w-full px-3 py-2 text-sm text-[#444] font-normal bg-white rounded-md border border-[#DCDCDC] appearance-none peer focus:outline-none focus:ring-0 focus:border-[#c19725]" />
              <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
                SGST %
              </label>
            </div>


            <div class="w-1/2 relative">
              <input type="text" placeholder=" " formControlName="stout_sgst_charge"
                class="block w-full px-3 py-2 text-sm text-[#444] font-normal bg-white rounded-md border border-[#DCDCDC] appearance-none peer focus:outline-none focus:ring-0 focus:border-[#c19725]" />
              <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
                SGST Charge
              </label>
            </div>

          </div> -->
<!--
          <div class="flex w-full gap-2">


            <div class="w-1/2 relative">
              <input type="text" placeholder=" " formControlName="stout_igst_percent"
                class="block w-full px-3 py-2 text-sm text-[#444] font-normal bg-white rounded-md border border-[#DCDCDC] appearance-none peer focus:outline-none focus:ring-0 focus:border-[#c19725]" />
              <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
                IGST %
              </label>
            </div>


            <div class="w-1/2 relative">
              <input type="text" placeholder=" " formControlName="stout_igst_charge"
                class="block w-full px-3 py-2 text-sm text-[#444] font-normal bg-white rounded-md border border-[#DCDCDC] appearance-none peer focus:outline-none focus:ring-0 focus:border-[#c19725]" />
              <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
                IGST Charge
              </label>
            </div>

          </div> -->



          <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_unit_price"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Item
                Rate</label>
            </div>
          </div>



          <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_hsn_no"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Hsn
                No</label>
            </div>
          </div>


          <!-- <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_hallmark_uid"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Hallmark
                UID </label>
            </div>
          </div> -->

<!--
          <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_total_hallmarking_charges"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Total
                Hallmarking Charges</label>
            </div>
          </div> -->


          <!-- <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_other_info"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Other
                Info</label>
            </div>
          </div> -->


          <!-- <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_model_no"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Model
                No</label>
            </div>
          </div> -->


          <!-- <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_counter_name"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Counter
                Name</label>
            </div>
          </div> -->

          <!-- <div class="flex w-full gap-2 items-center">


            <div class="w-3/5 relative">
              <input type="text" placeholder=" " formControlName="stout_other_charges"
                class="block w-full px-3 py-2 text-sm text-[#444] font-normal bg-white rounded-md border border-[#DCDCDC] appearance-none peer focus:outline-none focus:ring-0 focus:border-[#c19725]" />
              <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
                Other Charges
              </label>
            </div>


            <div class="w-2/5">
              <app-custom-select label="Unit" [options]="unitTypes" formControlName="stout_other_charges_unit"
                [(selected)]="selectedNetWtUnit" selectId="netWtUnit">
              </app-custom-select>
            </div>

          </div> -->

          <!-- <div class="flex w-full gap-2 items-center">


            <div class="w-3/5 relative">
              <input type="text" placeholder=" " formControlName="stout_making_charges"
                class="block w-full px-3 py-2 text-sm text-[#444] font-normal bg-white rounded-md border border-[#DCDCDC] appearance-none peer focus:outline-none focus:ring-0 focus:border-[#c19725]" />
              <label class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5
                     peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                     peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
                Mk Charge
              </label>
            </div>


            <div class="w-2/5">
              <app-custom-select label="Unit" [options]="unitTypes" formControlName="stout_mk_charge_unit"
                [(selected)]="selectedMakingChargesUnit" selectId="selectedMakingChargesUnit">
              </app-custom-select>
            </div>

          </div> -->


          <!-- <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_metal_rate"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Metal
                Valuation</label>
            </div>
          </div> -->
<!--
          <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_metal_discount_amount"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Metal
                Discount Amount</label>
            </div>
          </div> -->

          <div class="col-span-1">
            <div class="relative w-full">
              <input type="text" placeholder=" " formControlName="stout_final_amount"
                class="block px-2 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none peer focus:outline-none focus:ring-0 focus:border-c19725" />
              <label
                class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">Final
                Amount</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex justify-center">
    <button type="button" (click)="submitForm()"
      class="block cursor-pointer capitalize w-[110px] lg:w-[200px] p-1 md:p-1.5 center text-base xl:text-lg font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center dark:text-c19725 dark:bg-c19725 dark:hover:bg-fdffc6 __web-inspector-hide-shortcut__">
      Submit </button>
  </div>
  </form>
  </div>
</div>

<!-- Rest of your HTML remains the same... -->
